import { useEffect } from "react";
import likeImage from "../../assets/like.svg";
import unlikeImage from "../../assets/unlike.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchLikesUnlikes,
  LikesUnlikes,
} from "../../features/likeUnlike/likeUnlikeSlice";

export default function LikeUnlike({ id }) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchLikesUnlikes(id));
  }, [dispatch, id]);

  const { likes, unlikes } = useSelector((state) => state.likesUnlikes);

  const hanldeLikesUnlikes = (id, likesOrUnlikesNo, likesOrUnlikes) => {
    dispatch(LikesUnlikes({ id, likesOrUnlikesNo, likesOrUnlikes }));
  };
  return (
    <div className="flex gap-10 w-48">
      <div className="flex gap-1">
        <div className="shrink-0">
          <img
            className="w-5 block"
            src={likeImage}
            alt="Like"
            onClick={() => hanldeLikesUnlikes(id, likes + 1, "likes")}
          />
        </div>
        <div className="text-sm leading-[1.7142857] text-slate-600">
          {likes}
        </div>
      </div>
      <div className="flex gap-1">
        <div className="shrink-0">
          <img
            className="w-5 block"
            src={unlikeImage}
            alt="Unlike"
            onClick={() => hanldeLikesUnlikes(id, unlikes + 1, "unlikes")}
          />
        </div>
        <div className="text-sm leading-[1.7142857] text-slate-600">
          {unlikes}
        </div>
      </div>
    </div>
  );
}
